'use strict';

var _tslib = require('./_tslib-17936c8d.js');
var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useHasMounted() {
    var _a = _tslib.__read(React__namespace.useState(false), 2), hasMounted = _a[0], setHasMounted = _a[1];
    React__namespace.useEffect(function () {
        setHasMounted(true);
    }, []);
    return hasMounted;
}

exports.useHasMounted = useHasMounted;
//# sourceMappingURL=UseHasMounted-b444dd79.js.map
